import React, {useState} from 'react';
import {TextField} from '@mui/material';
import {isAtInAddress, isFilled, isValidEmailAddress} from 'app/components/helpers/ValidationRules';
import {StyledButton} from 'app/styles/content';
import {sendEmailToResetPassword} from 'app/services/firebase';
import {useForm} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {selectButtonType} from 'app/hooks/reduxCreateSelectorHooks';

const EmailFormResetPass = ({setIsSending, onError, onSuccess}) => {
  const buttonType = useSelector(selectButtonType);
  const [disableButton, setDisableButton] = useState(false);
  const {register, handleSubmit, errors} = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  const onSubmit = ({email}) => {
    onError(null, '');
    setDisableButton(true);
    setIsSending(true);
    // function is only called, when inputs are valid
    sendEmailToResetPassword(email)
      .then(() => {
        setIsSending(false);
        onSuccess(email);
      })
      .catch((error) => {
        setDisableButton(false);
        onError(error, email);
        setIsSending(false);
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        variant="standard"
        autoComplete='email'
        autoFocus={true}
        color='secondary'
        error={!!errors.email}
        fullWidth={true}
        helperText={errors.email ? errors.email.message : ' '}
        id='email-reset-password'
        InputLabelProps={{required: false}}
        inputProps={{tabIndex: '1'}}
        inputRef={register({
          validate: {
            isFilled,
            isAtInAddress,
            isValidEmailAddress,
          },
        })}
        label='E-Mail'
        name='email'
        placeholder='max.mustermann@mail.de'
        required={true}
        type='email' />
      <StyledButton justify='center' type={buttonType} label='Link zum Zurücksetzen senden' disabled={disableButton} />
    </form>
  );
};

export {EmailFormResetPass};
